import React from 'react';
import PropTypes from 'prop-types';

const AdminReportsDataListItemTeam = ({ item }) => (
  <td>
    <a href={`/admin/teams/${item.uuid}/edit`} target="_blank" rel="noopener noreferrer">
      {item.name}
    </a>
  </td>
);

AdminReportsDataListItemTeam.propTypes = {
  item: PropTypes.object.isRequired,
};

export default AdminReportsDataListItemTeam;
